














































































import { Vue, Component } from "vue-property-decorator";
import CommonDialog from "../../components/organisms/CommonDialog.vue";
import LineOfficialConnectionDialog from "../../components/line/LineOfficialConnectionDialog.vue";
import { URIs } from "../../../src_server/common/URIs";
import TeacherPaymentDialog from "./TeacherPaymentDialog.vue";
import { Session } from "../../utils/Session";

@Component({
  components: { CommonDialog, LineOfficialConnectionDialog, TeacherPaymentDialog },
})
export default class TeacherDocumentListDialog extends Vue {
  private redirectPath = URIs.LINE_NOTIFY_CONNECT_TEA_DONE.path;

  public async show() {
    (this.$refs["document_list"] as CommonDialog).show();
  }

  public close() {
    (this.$refs["document_list"] as CommonDialog).hide();
  }
  showManual() {
    window.open(
      "https://docs.google.com/document/d/1LYXr-E3K4oXrrgb5ceYrjiAP10iDqGtfikUs7GranKY/edit",
      "_blank"
    );
  }
  shwoFAQ() {
    window.open(
      "https://docs.google.com/document/d/1Kd24oI4JPbuBvtE-cc-nKxYmp29oURIcutILo6KUTIA/edit",
      "_blank"
    );
  }

  shwoDocument() {
    window.open(
      "https://docs.google.com/spreadsheets/d/1k1SzfXviJs3hlQbRWw2w1Hc8bqXYcGjE4PXOuaPOlnc/edit#gid=431461394",
      "_blank"
    );
  }
  cancelPolicy() {
    window.open(
      "https://docs.google.com/document/d/1lkYD-J1riWKVm9-JyA9sx0Y4YymwoBnAPJX0Dmutqok/edit",
      "_blank"
    );
  }

  rules() {
    window.open(
      "https://docs.google.com/document/d/1tL7rup1-3cRflbC-XoH1J8Icu5aJEKFna6AptLyab8E/edit",
      "_blank"
    );
  }

  async showOffical() {
    await (this.$refs[
      "LineOfficialConnectionDialog"
    ] as LineOfficialConnectionDialog).show();
  }
  async payment() {
    await (this.$refs["TeacherPaymentDialog"] as TeacherPaymentDialog).show(
      Session.getSessionUserId(),
      Session.getSessionBuildingId()
    );
  }
}
